import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = {
  key: 0,
  class: "mb-4 text-red-600"
}
const _hoisted_4 = {
  key: 1,
  class: "mb-4 text-gray-600"
}
const _hoisted_5 = { class: "grid gap-4 md:grid-cols-2" }
const _hoisted_6 = { class: "grid gap-4 md:grid-cols-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[26] || (_cache[26] = _createStaticVNode("<nav aria-label=\"Breadcrumb\" class=\"flex\"><ol class=\"inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse\"><li class=\"inline-flex items-center\"><a class=\"inline-flex items-center text-sm font-medium text-gray-700 hover:text-primary dark:text-gray-400 dark:hover:text-white\" href=\"#\"> Admin </a></li><li><div class=\"flex items-center\"><svg aria-hidden=\"true\" class=\"w-3 h-3 mx-1 text-gray-400 rtl:rotate-180\" fill=\"none\" viewBox=\"0 0 6 10\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m1 9 4-4-4-4\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path></svg><a class=\"text-sm font-medium text-black ms-1 hover:text-primary md:ms-2 dark:text-white dark:hover:text-white\" href=\"#\"> Settings </a></div></li></ol></nav>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[25] || (_cache[25] = _createElementVNode("h2", { class: "mb-4 text-xl font-semibold leading-none text-gray-900 dark:text-white" }, " Site Settings ", -1)),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading... "))
        : _createCommentVNode("", true),
      (!_ctx.loading && _ctx.settings)
        ? (_openBlock(), _createElementBlock("form", {
            key: 2,
            class: "space-y-6",
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateSettings && _ctx.updateSettings(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                  for: "siteTitle"
                }, " Site Title ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "siteTitle",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.settings.siteTitle) = $event)),
                  class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white",
                  placeholder: "Enter the site title",
                  required: "",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.settings.siteTitle]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[13] || (_cache[13] = _createElementVNode("label", {
                  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                  for: "siteDescription"
                }, " Site Description ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "siteDescription",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settings.siteDescription) = $event)),
                  class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white",
                  placeholder: "Enter the site description",
                  required: "",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.settings.siteDescription]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[14] || (_cache[14] = _createElementVNode("label", {
                  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                  for: "metaTitle"
                }, " Meta Title ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "metaTitle",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settings.metaTitle) = $event)),
                  class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white",
                  placeholder: "Enter the meta title",
                  required: "",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.settings.metaTitle]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[15] || (_cache[15] = _createElementVNode("label", {
                  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                  for: "metaDescription"
                }, " Meta Description ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "metaDescription",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.settings.metaDescription) = $event)),
                  class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white",
                  placeholder: "Enter the meta description",
                  required: "",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.settings.metaDescription]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[16] || (_cache[16] = _createElementVNode("label", {
                  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                  for: "metaKeywords"
                }, " Meta Keywords ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "metaKeywords",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.settings.metaKeywords) = $event)),
                  class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white",
                  placeholder: "Enter meta keywords",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.settings.metaKeywords]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[17] || (_cache[17] = _createElementVNode("label", {
                  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                  for: "contactPhone"
                }, " Contact Phone ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "contactPhone",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.settings.contactPhone) = $event)),
                  class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white",
                  placeholder: "Enter contact phone",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.settings.contactPhone]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[18] || (_cache[18] = _createElementVNode("label", {
                  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                  for: "contactEmail"
                }, " Contact Email ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "contactEmail",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.settings.contactEmail) = $event)),
                  class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white",
                  placeholder: "Enter contact email",
                  type: "email"
                }, null, 512), [
                  [_vModelText, _ctx.settings.contactEmail]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[19] || (_cache[19] = _createElementVNode("label", {
                  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                  for: "address"
                }, " Address ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "address",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.settings.address) = $event)),
                  class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white",
                  placeholder: "Enter the address",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.settings.address]
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "mt-6 mb-4 text-lg font-medium text-gray-900 dark:text-white" }, " Social Media Links ", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", {
                    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                    for: "facebook"
                  }, " Facebook ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "facebook",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.settings.socialLinks.facebook) = $event)),
                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white",
                    placeholder: "Enter Facebook URL",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.settings.socialLinks.facebook]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", {
                    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                    for: "twitter"
                  }, " Twitter ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "twitter",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.settings.socialLinks.twitter) = $event)),
                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white",
                    placeholder: "Enter Twitter URL",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.settings.socialLinks.twitter]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", {
                    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
                    for: "instagram"
                  }, " Instagram ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "instagram",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.settings.socialLinks.instagram) = $event)),
                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white",
                    placeholder: "Enter Instagram URL",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.settings.socialLinks.instagram]
                  ])
                ])
              ])
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("button", {
              class: "inline-flex items-center px-5 py-3 text-sm font-medium text-center text-white bg-black rounded-lg hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-gray-300 dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800",
              type: "submit"
            }, " Update Settings ", -1))
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}